// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export function tablesNamedKeyCredentialPolicy(_credential) {
    throw new Error("Shared Access Key authentication is not supported in the browser");
}
export function getAuthorizationHeader(_request, _credential) {
    throw new Error("Shared Access Key authentication is not supported in the browser");
}
//# sourceMappingURL=tablesNamedCredentialPolicy.browser.js.map